var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4,299.2c-13.68,13.39-16,34.11-13.1,52.26.08.41.72.3.72-.09,0-4.13-.13-8.22-.12-12.3.08-.19.14-.37.22-.55C90.69,335.92,94,333,96,329c2.29-4.5,3.19-9.56,4.93-14.26.17-.45-.31-.32-.63-.08-8.32,6.13-11,12.74-13.36,21.56a72.87,72.87,0,0,1,1.45-13.74c1.8-8.37,5.35-16.68,11.37-22.89A.25.25,0,0,0,99.4,299.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,300.76c2.35.08,3.83,3.84,5.66,4.94a1.77,1.77,0,0,0,2.6-.41c1.82-2.54-.68-5.67-3-7.42,1.68.69,3.07,1.9,4.88,2.25a1.71,1.71,0,0,0,2.2-1.32c.79-3.46-3.54-5-6.52-5.07,1.44-1,5.58-3.73,3.38-5.07s-7.08,2.55-8.66,3.83c-2.33,1.89-5.1,4.71-5.21,7.66C97.15,303.6,100.16,301.48,102,300.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,301.34c3-1.37,8.79.6,9.28-.54,1-2.32-3.62-3.91-6.12-4.22,2.3-.62,6.7-1.61,6.57-3.82-.17-2.71-6.75-.38-10.09,2.17-4.19,3.22-4.17,6.33-3.47,6.95C98.41,302.73,100.79,301.56,101.29,301.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24,297.87c14.18,12.86,17.27,33.48,15.07,51.73,0,.41-.7.33-.71-.06-.16-4.13-.19-8.23-.36-12.3l-.23-.55c-3.66-2.45-7.06-5.26-9.24-9.2-2.46-4.4-3.55-9.43-5.47-14.06-.18-.44.3-.33.62-.11,8.55,5.82,11.46,12.32,14.18,21.05a73.62,73.62,0,0,0-2-13.68c-2.12-8.3-6-16.46-12.24-22.44C67.66,298,68,297.64,68.24,297.87Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.73,299.53c-2.35.17-3.68,4-5.47,5.15a1.76,1.76,0,0,1-2.61-.31c-1.91-2.47.46-5.69,2.74-7.53-1.65.76-3,2-4.79,2.43A1.7,1.7,0,0,1,53.35,298c-.93-3.43,3.35-5.13,6.32-5.32-1.48-.94-5.72-3.51-3.57-4.93s7.17,2.28,8.8,3.5c2.4,1.8,5.28,4.51,5.49,7.46C70.66,302.19,67.57,300.18,65.73,299.53Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.43,300.08c-3.05-1.25-8.76.94-9.29-.18-1.08-2.28,3.47-4,6-4.45-2.32-.53-6.75-1.36-6.7-3.57.06-2.71,6.73-.64,10.16,1.79,4.31,3.06,4.4,6.16,3.73,6.81C69.37,301.37,66.94,300.29,66.43,300.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,331.84a139.59,139.59,0,0,0,4.41,20.34.51.51,0,0,0,1-.2c-.93-6.26-2.63-12.42-3.56-18.68a93.45,93.45,0,0,1-1.09-19.19c.59-10.56,3.46-21.8,10.35-30.06.16-.2-.17-.47-.32-.29-13.8,16.09-11.6,35.81-11.59,37.58-2-6.66-4-14.3-11.36-21.08-.32-.29-.57-.15-.51.35C71.38,313,74.81,319.41,82,326,82.18,328,82.43,329.92,82.74,331.84Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,285.9c2.48-1.1,5.91,2.06,8.36,2.27a2,2,0,0,0,2.49-1.73c.61-3.55-3.55-5.54-6.87-6.17,2.09-.13,4.14.42,6.19-.13a2,2,0,0,0,1.62-2.48c-.91-4-6.19-3.4-9.31-2,1-1.77,3.91-6.68,1-7s-6.06,6.21-7.05,8.34c-1.47,3.13-2.93,7.46-1.55,10.57C90.4,291.28,92.45,287.56,94,285.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.55,286.84c2.44-2.93,9.43-3.8,9.36-5.23-.13-2.9-5.72-2.23-8.46-1.29,2.06-1.8,6.13-5.05,4.88-7.28-1.54-2.72-7.2,3-9.37,7.34-2.73,5.45-1.14,8.66-.11,8.95C91.27,289.74,93.15,287.33,93.55,286.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,335.56l-6.08,46.5h37c-.76-4.12-7.65-46.55-7.65-46.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.79,
    y: 188.44,
    width: 26.48,
    height: 11.19,
    transform: "translate(896.07 388.07) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.56,
    y: 174.33,
    width: 26.48,
    height: 11.19,
    transform: "translate(925.61 359.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.02,
    y: 174.33,
    width: 26.48,
    height: 11.19,
    transform: "translate(866.52 359.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.73,
    y: 332.76,
    width: 26.48,
    height: 11.19,
    transform: "translate(103.93 676.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.96,
    y: 318.65,
    width: 26.48,
    height: 11.19,
    transform: "translate(74.39 648.49) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.56,
    y: 332.75,
    width: 26.48,
    height: 11.19,
    transform: "translate(925.61 676.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.43,
    y: 95.26,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.65,
    y: 109.37,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-300"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "57.95 382.02 105.96 381.78 153.97 381.69 250 381.52 346.02 381.69 394.04 381.78 442.05 382.02 394.04 382.27 346.02 382.35 250 382.52 153.97 382.35 105.96 382.26 57.95 382.02",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-404--inject-300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.4,239.88h0a9.17,9.17,0,0,0-.82-.83h0a10.7,10.7,0,0,0-.83-.82s0,0,0,0a10.7,10.7,0,0,0-.82-.83h0a9.17,9.17,0,0,0-.83-.82h0c-.26-.29-.54-.57-.82-.83h0a7.93,7.93,0,0,0-.82-.82h0a10.83,10.83,0,0,0-.83-.83h0a7.93,7.93,0,0,0-.82-.82s0,0,0,0a10.7,10.7,0,0,0-.83-.82s0,0,0,0a11.93,11.93,0,0,0-2.93-2.35V147.47c0-.44-.21-.66-.21-1.1a2.35,2.35,0,0,0-.22-1.31c0-.22-.21-.66-.21-.88a10.41,10.41,0,0,0-.45-1.32,1.61,1.61,0,0,1-.43-.88,6.28,6.28,0,0,0-.88-1.09c-.23-.22-.44-.65-.66-.88l-.88-.88c0-.13-.17-.27-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.36l-.43-.43,0,0c0-.14-.17-.27-.36-.36l-.43-.44,0,0c0-.13-.17-.27-.36-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.13-.16-.27-.35-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.35l-.48-.48c0-.22-.43-.44-.66-.44a.21.21,0,0,0-.21-.22c-.44-.21-.67-.44-1.1-.66a13.54,13.54,0,0,1-1.09-.88c-.22,0-.66-.21-.88-.21-.44-.22-1.1-.22-1.32-.45a2.1,2.1,0,0,1-1.1-.21h-3.72a1.37,1.37,0,0,1-.88.21c-.66.23-1.09.23-1.32.45-.43,0-.65.21-.88.66a2.38,2.38,0,0,0-1.31.43c-.21.22-.66.45-.88.66a2.25,2.25,0,0,1-1.09.66,3,3,0,0,1-.66.88c-.22.22-.22.43-.43.43L52,233a11.71,11.71,0,0,0,1.09,16.13,7.4,7.4,0,0,0,.84.84,6.51,6.51,0,0,0,.83.83,7.4,7.4,0,0,0,.84.84,7.31,7.31,0,0,0,.83.84,7.31,7.31,0,0,0,.84.83,7.31,7.31,0,0,0,.83.84,7.31,7.31,0,0,0,.84.83,7.31,7.31,0,0,0,.83.84,7.31,7.31,0,0,0,.84.83,11.38,11.38,0,0,0,1.72,1.59,10.75,10.75,0,0,0,7.45,2.63h60.72v8.31a12,12,0,0,0,3.92,9l0,0c.26.28.53.55.8.8,0,0,0,0,0,0a10.32,10.32,0,0,0,.81.81l0,0c.26.28.53.55.81.8l0,0a10.32,10.32,0,0,0,.81.81l0,0q.39.42.81.81l0,0a8.85,8.85,0,0,0,.81.81l0,0c.25.28.52.55.8.81l0,0a10.32,10.32,0,0,0,.81.81l0,0c.25.27.52.54.8.8l0,0a12.11,12.11,0,0,0,21-8.19V260.83h2.2a12.07,12.07,0,0,0,12.27-12.06A12,12,0,0,0,173.4,239.88Zm-42.92-47v35.44H101.92Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.4,239.88h0a9.17,9.17,0,0,0-.82-.83h0a10.7,10.7,0,0,0-.83-.82s0,0,0,0a10.7,10.7,0,0,0-.82-.83h0a9.17,9.17,0,0,0-.83-.82h0c-.26-.29-.54-.57-.82-.83h0a7.93,7.93,0,0,0-.82-.82h0a10.83,10.83,0,0,0-.83-.83h0a7.93,7.93,0,0,0-.82-.82s0,0,0,0a10.7,10.7,0,0,0-.83-.82s0,0,0,0a11.93,11.93,0,0,0-2.93-2.35V147.47c0-.44-.21-.66-.21-1.1a2.35,2.35,0,0,0-.22-1.31c0-.22-.21-.66-.21-.88a10.41,10.41,0,0,0-.45-1.32,1.61,1.61,0,0,1-.43-.88,6.28,6.28,0,0,0-.88-1.09c-.23-.22-.44-.65-.66-.88l-.88-.88c0-.13-.17-.27-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.36l-.43-.43,0,0c0-.14-.17-.27-.36-.36l-.43-.44,0,0c0-.13-.17-.27-.36-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.13-.16-.27-.35-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.35l-.48-.48c0-.22-.43-.44-.66-.44a.21.21,0,0,0-.21-.22c-.44-.21-.67-.44-1.1-.66a13.54,13.54,0,0,1-1.09-.88c-.22,0-.66-.21-.88-.21-.44-.22-1.1-.22-1.32-.45a2.1,2.1,0,0,1-1.1-.21h-3.72a1.37,1.37,0,0,1-.88.21c-.66.23-1.09.23-1.32.45-.43,0-.65.21-.88.66a2.38,2.38,0,0,0-1.31.43c-.21.22-.66.45-.88.66a2.25,2.25,0,0,1-1.09.66,3,3,0,0,1-.66.88c-.22.22-.22.43-.43.43L52,233a11.71,11.71,0,0,0,1.09,16.13,7.4,7.4,0,0,0,.84.84,6.51,6.51,0,0,0,.83.83,7.4,7.4,0,0,0,.84.84,7.31,7.31,0,0,0,.83.84,7.31,7.31,0,0,0,.84.83,7.31,7.31,0,0,0,.83.84,7.31,7.31,0,0,0,.84.83,7.31,7.31,0,0,0,.83.84,7.31,7.31,0,0,0,.84.83,11.38,11.38,0,0,0,1.72,1.59,10.75,10.75,0,0,0,7.45,2.63h60.72v8.31a12,12,0,0,0,3.92,9l0,0c.26.28.53.55.8.8,0,0,0,0,0,0a10.32,10.32,0,0,0,.81.81l0,0c.26.28.53.55.81.8l0,0a10.32,10.32,0,0,0,.81.81l0,0q.39.42.81.81l0,0a8.85,8.85,0,0,0,.81.81l0,0c.25.28.52.55.8.81l0,0a10.32,10.32,0,0,0,.81.81l0,0c.25.27.52.54.8.8l0,0a12.11,12.11,0,0,0,21-8.19V260.83h2.2a12.07,12.07,0,0,0,12.27-12.06A12,12,0,0,0,173.4,239.88Zm-42.92-47v35.44H101.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,240.41a12.07,12.07,0,0,1-12.28,12.06h-2.19v16.67a12.06,12.06,0,0,1-24.12,0V252.47H61.4A10.71,10.71,0,0,1,54,249.84,11.73,11.73,0,0,1,52,233L133.1,132.09c.22,0,.22-.21.44-.43a3,3,0,0,0,.66-.88,2.35,2.35,0,0,0,1.1-.66c.21-.22.65-.44.87-.66a2.36,2.36,0,0,1,1.32-.44c.22-.43.44-.65.88-.65.21-.22.65-.22,1.31-.44a1.32,1.32,0,0,0,.88-.22h3.73a1.93,1.93,0,0,0,1.09.22c.22.22.88.22,1.32.44.22,0,.66.22.88.22.43.43.87.65,1.09.87.44.22.66.44,1.1.66a.22.22,0,0,1,.22.22c.22,0,.66.22.66.44l.87.88c.22.22.44.65.66.87a6,6,0,0,1,.88,1.1,1.67,1.67,0,0,0,.44.88,8,8,0,0,1,.43,1.31c0,.22.22.66.22.88a2.38,2.38,0,0,1,.22,1.32c0,.43.22.65.22,1.09v89.24h2.19A12.22,12.22,0,0,1,169.06,240.41Zm-38.59-66.22L86.84,228.35h43.63Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33,160.4A62.28,62.28,0,0,0,288.75,150a4.4,4.4,0,0,0-.38-.37l-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3a1.14,1.14,0,0,0-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3s-.07-.08-.11-.11a3.22,3.22,0,0,0-.32-.32c-.27-.31-.57-.58-.86-.87l-.08-.07a2.83,2.83,0,0,0-.3-.3s-.07-.08-.11-.11c-8.81-9.08-20.29-15.09-33.17-15.09-17.33,0-31.57,10.31-40.79,24.33-9.65,14-14.68,32.25-14.9,52.41.22,20,5.25,38.37,14.9,52.41a65.26,65.26,0,0,0,8.49,10.29l.44.43,0,.05.78.78c.13.15.27.28.4.41l.44.43.05.05.78.78.4.42.44.42a.12.12,0,0,1,.05.05l.78.78.4.42.44.42a.1.1,0,0,1,.05.06l.78.78.41.41.43.42.06.06.78.78c8.66,8.65,19.84,14.46,32.69,14.46,16.88,0,31.35-10.53,40.57-24.35,9.42-14,14.69-32.45,14.69-52.4C312,192.64,306.75,174.44,297.33,160.4ZM268.8,243.27c-6.36,9.42-13.6,13.59-20.39,13.59a20.15,20.15,0,0,1-11.57-4c-.31-.4-.61-.82-.91-1.26-6.14-9.21-10.53-23.24-10.53-38.81,0-15.79,4.39-29.6,10.53-39,6.59-9.21,14-13.59,20.83-13.38a18.35,18.35,0,0,1,11,3.6c.35.47.69.93,1,1.42,6.14,9.43,10.52,23.24,10.52,39C279.32,220,274.94,234.05,268.8,243.27Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33,160.4A62.28,62.28,0,0,0,288.75,150a4.4,4.4,0,0,0-.38-.37l-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3a1.14,1.14,0,0,0-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3s-.07-.08-.11-.11a3.22,3.22,0,0,0-.32-.32c-.27-.31-.57-.58-.86-.87l-.08-.07a2.83,2.83,0,0,0-.3-.3s-.07-.08-.11-.11c-8.81-9.08-20.29-15.09-33.17-15.09-17.33,0-31.57,10.31-40.79,24.33-9.65,14-14.68,32.25-14.9,52.41.22,20,5.25,38.37,14.9,52.41a65.26,65.26,0,0,0,8.49,10.29l.44.43,0,.05.78.78c.13.15.27.28.4.41l.44.43.05.05.78.78.4.42.44.42a.12.12,0,0,1,.05.05l.78.78.4.42.44.42a.1.1,0,0,1,.05.06l.78.78.41.41.43.42.06.06.78.78c8.66,8.65,19.84,14.46,32.69,14.46,16.88,0,31.35-10.53,40.57-24.35,9.42-14,14.69-32.45,14.69-52.4C312,192.64,306.75,174.44,297.33,160.4ZM268.8,243.27c-6.36,9.42-13.6,13.59-20.39,13.59a20.15,20.15,0,0,1-11.57-4c-.31-.4-.61-.82-.91-1.26-6.14-9.21-10.53-23.24-10.53-38.81,0-15.79,4.39-29.6,10.53-39,6.59-9.21,14-13.59,20.83-13.38a18.35,18.35,0,0,1,11,3.6c.35.47.69.93,1,1.42,6.14,9.43,10.52,23.24,10.52,39C279.32,220,274.94,234.05,268.8,243.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.71,204.45c.22-20.17,5.27-38.37,14.91-52.4,9.21-14,23.46-24.34,40.79-24.34,16.88,0,31.35,10.31,40.56,24.34,9.43,14,14.69,32.23,14.69,52.4,0,20-5.26,38.38-14.69,52.41-9.21,13.81-23.68,24.34-40.56,24.34-17.33,0-31.58-10.53-40.79-24.34C198,242.83,192.93,224.41,192.71,204.45Zm86.61,0c0-15.78-4.38-29.6-10.52-39-6.36-9.21-13.59-13.59-20.39-13.37-6.8-.22-14.26,4.16-20.83,13.37-6.14,9.43-10.53,23.25-10.53,39,0,15.57,4.39,29.61,10.53,38.81,6.57,9.43,14,13.6,20.83,13.6s14-4.17,20.39-13.6C274.94,234.06,279.32,220,279.32,204.45Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.71,239.88h0c-.26-.29-.54-.57-.82-.83h0c-.27-.29-.55-.56-.83-.82,0,0,0,0,0,0-.27-.29-.54-.57-.82-.83h0c-.27-.29-.55-.57-.83-.82h0c-.27-.29-.54-.57-.82-.83h0c-.27-.29-.55-.57-.83-.82h0c-.27-.29-.55-.57-.82-.83h0a10.57,10.57,0,0,0-.82-.82s0,0,0,0c-.27-.29-.55-.56-.83-.82,0,0,0,0,0,0a11.75,11.75,0,0,0-2.94-2.35V147.47c0-.44-.21-.66-.21-1.1a2.35,2.35,0,0,0-.22-1.31c0-.22-.21-.66-.21-.88a10.41,10.41,0,0,0-.45-1.32,1.69,1.69,0,0,1-.43-.88,5.83,5.83,0,0,0-.88-1.09c-.23-.22-.44-.65-.66-.88l-.88-.88c0-.13-.17-.27-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.36l-.43-.43,0,0c0-.14-.17-.27-.36-.36l-.43-.44,0,0c0-.13-.17-.27-.36-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.13-.16-.27-.35-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.35l-.48-.48c0-.22-.43-.44-.66-.44a.22.22,0,0,0-.22-.22c-.43-.21-.66-.44-1.09-.66a13.54,13.54,0,0,1-1.09-.88c-.22,0-.66-.21-.88-.21-.44-.22-1.09-.22-1.32-.45a2.08,2.08,0,0,1-1.1-.21h-3.72a1.37,1.37,0,0,1-.88.21c-.66.23-1.09.23-1.32.45-.43,0-.65.21-.88.66a2.4,2.4,0,0,0-1.31.43c-.21.22-.66.45-.87.66a2.35,2.35,0,0,1-1.1.66,3.18,3.18,0,0,1-.66.88c-.22.22-.22.43-.43.43L325.28,233a11.71,11.71,0,0,0,1.09,16.13,7.4,7.4,0,0,0,.84.84,6.51,6.51,0,0,0,.83.83,7.4,7.4,0,0,0,.84.84,295.81,295.81,0,0,1,2.5,2.51,98.61,98.61,0,0,1,1.67,1.67,7.31,7.31,0,0,0,.84.83,11.38,11.38,0,0,0,1.72,1.59,10.75,10.75,0,0,0,7.45,2.63h60.72v8.31a12,12,0,0,0,3.92,9s0,0,0,0c.26.29.54.56.81.81l0,0c.25.28.52.54.8.8l0,0a10.42,10.42,0,0,0,.82.81l0,0c.26.28.52.54.8.8l0,0c.26.29.54.56.82.82l0,0c.26.28.52.55.8.8l0,0c.26.29.54.56.82.82l0,0c.26.28.52.55.8.8l0,0a10.45,10.45,0,0,0,.81.82l0,0a12.11,12.11,0,0,0,21-8.2V260.83h2.2a12.08,12.08,0,0,0,12.29-12.06A12,12,0,0,0,446.71,239.88Zm-42.93-47v35.44H375.22Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.71,239.88h0c-.26-.29-.54-.57-.82-.83h0c-.27-.29-.55-.56-.83-.82,0,0,0,0,0,0-.27-.29-.54-.57-.82-.83h0c-.27-.29-.55-.57-.83-.82h0c-.27-.29-.54-.57-.82-.83h0c-.27-.29-.55-.57-.83-.82h0c-.27-.29-.55-.57-.82-.83h0a10.57,10.57,0,0,0-.82-.82s0,0,0,0c-.27-.29-.55-.56-.83-.82,0,0,0,0,0,0a11.75,11.75,0,0,0-2.94-2.35V147.47c0-.44-.21-.66-.21-1.1a2.35,2.35,0,0,0-.22-1.31c0-.22-.21-.66-.21-.88a10.41,10.41,0,0,0-.45-1.32,1.69,1.69,0,0,1-.43-.88,5.83,5.83,0,0,0-.88-1.09c-.23-.22-.44-.65-.66-.88l-.88-.88c0-.13-.17-.27-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.36l-.43-.43,0,0c0-.14-.17-.27-.36-.36l-.43-.44,0,0c0-.13-.17-.27-.36-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.13-.16-.27-.35-.36l-.44-.43,0-.05c0-.13-.17-.26-.36-.35l-.43-.44-.05,0c0-.14-.16-.27-.35-.36l-.44-.43,0,0c0-.13-.17-.27-.36-.35l-.48-.48c0-.22-.43-.44-.66-.44a.22.22,0,0,0-.22-.22c-.43-.21-.66-.44-1.09-.66a13.54,13.54,0,0,1-1.09-.88c-.22,0-.66-.21-.88-.21-.44-.22-1.09-.22-1.32-.45a2.08,2.08,0,0,1-1.1-.21h-3.72a1.37,1.37,0,0,1-.88.21c-.66.23-1.09.23-1.32.45-.43,0-.65.21-.88.66a2.4,2.4,0,0,0-1.31.43c-.21.22-.66.45-.87.66a2.35,2.35,0,0,1-1.1.66,3.18,3.18,0,0,1-.66.88c-.22.22-.22.43-.43.43L325.28,233a11.71,11.71,0,0,0,1.09,16.13,7.4,7.4,0,0,0,.84.84,6.51,6.51,0,0,0,.83.83,7.4,7.4,0,0,0,.84.84,295.81,295.81,0,0,1,2.5,2.51,98.61,98.61,0,0,1,1.67,1.67,7.31,7.31,0,0,0,.84.83,11.38,11.38,0,0,0,1.72,1.59,10.75,10.75,0,0,0,7.45,2.63h60.72v8.31a12,12,0,0,0,3.92,9s0,0,0,0c.26.29.54.56.81.81l0,0c.25.28.52.54.8.8l0,0a10.42,10.42,0,0,0,.82.81l0,0c.26.28.52.54.8.8l0,0c.26.29.54.56.82.82l0,0c.26.28.52.55.8.8l0,0c.26.29.54.56.82.82l0,0c.26.28.52.55.8.8l0,0a10.45,10.45,0,0,0,.81.82l0,0a12.11,12.11,0,0,0,21-8.2V260.83h2.2a12.08,12.08,0,0,0,12.29-12.06A12,12,0,0,0,446.71,239.88Zm-42.93-47v35.44H375.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.36,240.41a12.07,12.07,0,0,1-12.28,12.06h-2.19v16.67a12.06,12.06,0,0,1-24.12,0V252.47H334.7a10.71,10.71,0,0,1-7.45-2.63,11.73,11.73,0,0,1-2-16.88L406.4,132.09c.22,0,.22-.21.44-.43a3,3,0,0,0,.66-.88,2.35,2.35,0,0,0,1.1-.66c.22-.22.66-.44.88-.66a2.3,2.3,0,0,1,1.31-.44c.22-.43.44-.65.87-.65.22-.22.66-.22,1.32-.44a1.32,1.32,0,0,0,.88-.22h3.73a1.93,1.93,0,0,0,1.09.22c.22.22.88.22,1.32.44.22,0,.66.22.88.22.44.43.87.65,1.09.87.44.22.66.44,1.1.66a.22.22,0,0,1,.22.22c.22,0,.65.22.65.44l.88.88c.22.22.44.65.66.87a6,6,0,0,1,.88,1.1,1.67,1.67,0,0,0,.44.88,9,9,0,0,1,.44,1.31c0,.22.21.66.21.88a2.38,2.38,0,0,1,.22,1.32c0,.43.22.65.22,1.09v89.24h2.19A12.22,12.22,0,0,1,442.36,240.41Zm-38.59-66.22-43.63,54.16h43.63Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49,103.68H165V108a1.11,1.11,0,0,1-2.22,0V96.22a1.1,1.1,0,0,1,1.1-1.1h3.58a4.28,4.28,0,1,1,0,8.56ZM165,101.46h2.46a2.06,2.06,0,1,0,0-4.12H165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,105.83h-4.86l-1,2.6a1.12,1.12,0,0,1-1,.7,1.16,1.16,0,0,1-.38-.06,1.13,1.13,0,0,1-.66-1.44l4.42-11.79a1.12,1.12,0,0,1,1.06-.7,1.1,1.1,0,0,1,1.06.7l4.42,11.79a1.13,1.13,0,0,1-.66,1.44,1.12,1.12,0,0,1-1.4-.64Zm-.82-2.2-1.62-4.31-1.62,4.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.73,101.94a7.29,7.29,0,0,1,7.38-7.22,7.39,7.39,0,0,1,4.56,1.56,1.15,1.15,0,0,1,.22,1.62,1.16,1.16,0,0,1-1.62.18A5.2,5.2,0,0,0,192.11,97a5,5,0,0,0-3.6,1.46,4.75,4.75,0,0,0,0,6.93,5,5,0,0,0,3.6,1.46,5.52,5.52,0,0,0,2.74-.76v-2.75H192a1.15,1.15,0,0,1-1.14-1.14,1.12,1.12,0,0,1,1.14-1.12h4a1.13,1.13,0,0,1,1.16,1.12v4.43a1.72,1.72,0,0,1-.06.34s0,.06,0,.1v0a1,1,0,0,1-.38.48,7.38,7.38,0,0,1-4.54,1.56A7.27,7.27,0,0,1,184.73,101.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.63,108V96.22a1.08,1.08,0,0,1,1.1-1.1h6.54a1.11,1.11,0,0,1,1.1,1.1,1.13,1.13,0,0,1-1.1,1.12h-5.42V101h4.66a1.11,1.11,0,0,1,0,2.22h-4.66v3.69h5.42a1.11,1.11,0,0,1,0,2.22h-6.48s0,0,0,0l0,0A1.1,1.1,0,0,1,201.63,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.69,108a1.09,1.09,0,1,1-2.18,0V96.38a1.08,1.08,0,0,1,.44-.92,1.1,1.1,0,0,1,1.52.24l6.46,9V96.4A1.09,1.09,0,0,1,229,95.32a1.11,1.11,0,0,1,1.1,1.08V108a1.11,1.11,0,0,1-1.1,1.1,1.08,1.08,0,0,1-.82-.4.53.53,0,0,1-.1-.12l-6.4-8.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,96.86A7.36,7.36,0,0,1,245,107a6.55,6.55,0,0,1-4.78,2.14,6.75,6.75,0,0,1-4.9-2.14,7.47,7.47,0,0,1,0-10.13,6.67,6.67,0,0,1,4.9-2.14A6.48,6.48,0,0,1,245,96.86Zm-.26,5.06a5.18,5.18,0,0,0-1.36-3.5,4.32,4.32,0,0,0-6.4,0,5.09,5.09,0,0,0-1.36,3.5,5,5,0,0,0,1.36,3.49,4.28,4.28,0,0,0,6.4,0A5.12,5.12,0,0,0,244.69,101.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.37,97.34h-3.18V108a1.08,1.08,0,0,1-1.1,1.1A1.1,1.1,0,0,1,253,108V97.34h-3.16a1.11,1.11,0,0,1-1.1-1.12,1.08,1.08,0,0,1,1.1-1.1h8.54a1.1,1.1,0,0,1,1.1,1.1A1.13,1.13,0,0,1,258.37,97.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,108V96.22a1.1,1.1,0,0,1,1.1-1.1h6.54a1.11,1.11,0,0,1,0,2.22H271V101h4.66a1.11,1.11,0,0,1,0,2.22H271V108a1.11,1.11,0,0,1-1.12,1.1A1.1,1.1,0,0,1,268.77,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,96.86a7.36,7.36,0,0,1,0,10.13,6.55,6.55,0,0,1-4.78,2.14,6.75,6.75,0,0,1-4.9-2.14,7.47,7.47,0,0,1,0-10.13,6.67,6.67,0,0,1,4.9-2.14A6.48,6.48,0,0,1,291.51,96.86Zm-.26,5.06a5.18,5.18,0,0,0-1.36-3.5,4.32,4.32,0,0,0-6.4,0,5.09,5.09,0,0,0-1.36,3.5,5,5,0,0,0,1.36,3.49,4.28,4.28,0,0,0,6.4,0A5.12,5.12,0,0,0,291.25,101.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.37,109.13a5.77,5.77,0,0,1-5.78-5.79V96.22a1.08,1.08,0,0,1,1.1-1.1,1.11,1.11,0,0,1,1.12,1.1v7.12a3.56,3.56,0,1,0,7.12,0V96.22a1.1,1.1,0,0,1,1.12-1.1,1.08,1.08,0,0,1,1.1,1.1v7.12A5.78,5.78,0,0,1,302.37,109.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.75,108a1.09,1.09,0,1,1-2.18,0V96.38a1.08,1.08,0,0,1,.44-.92,1.1,1.1,0,0,1,1.52.24l6.46,9V96.4a1.09,1.09,0,0,1,1.08-1.08,1.11,1.11,0,0,1,1.1,1.08V108a1.11,1.11,0,0,1-1.1,1.1,1.08,1.08,0,0,1-.82-.4.53.53,0,0,1-.1-.12l-6.4-8.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,108V96.22a1.08,1.08,0,0,1,1.1-1.1h2.36a7,7,0,0,1,0,14h-2.36A1.1,1.1,0,0,1,327,108Zm2.22-1.12h1.24a4.79,4.79,0,0,0,0-9.57h-1.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.28,
    y: 420.58,
    width: 139.43,
    height: 32.11,
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35,436.66a7.29,7.29,0,0,1,7.38-7.23,7.39,7.39,0,0,1,4.56,1.56,1.15,1.15,0,0,1,.22,1.62,1.16,1.16,0,0,1-1.62.18,5.2,5.2,0,0,0-3.16-1.08,5,5,0,0,0-3.6,1.46,4.75,4.75,0,0,0,0,6.93,5,5,0,0,0,3.6,1.46,5.52,5.52,0,0,0,2.74-.76v-2.74h-2.86a1.15,1.15,0,0,1-1.14-1.14,1.13,1.13,0,0,1,1.14-1.13h4a1.14,1.14,0,0,1,1.16,1.13v4.42a1.72,1.72,0,0,1-.06.34l0,.1v0a1,1,0,0,1-.38.48,7.38,7.38,0,0,1-4.54,1.56A7.27,7.27,0,0,1,218.35,436.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.29,431.57a7.36,7.36,0,0,1,0,10.13,6.55,6.55,0,0,1-4.78,2.14,6.75,6.75,0,0,1-4.9-2.14,7.47,7.47,0,0,1,0-10.13,6.67,6.67,0,0,1,4.9-2.14A6.48,6.48,0,0,1,246.29,431.57Zm-.26,5.07a5.21,5.21,0,0,0-1.36-3.51,4.32,4.32,0,0,0-6.4,0,5.11,5.11,0,0,0-1.36,3.51,5,5,0,0,0,1.36,3.48,4.28,4.28,0,0,0,6.4,0A5.09,5.09,0,0,0,246,436.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,442.74V430.93a1.1,1.1,0,0,1,1.1-1.1h2.84a3.81,3.81,0,0,1,3,6.09,4.28,4.28,0,0,1-2.26,7.92h-3.54a0,0,0,0,1,0,0s0,0-.06,0A1.11,1.11,0,0,1,258.25,442.74Zm2.22-7.49h1.72a1.6,1.6,0,0,0,1.58-1.62,1.57,1.57,0,0,0-1.58-1.58h-1.72Zm0,6.37H263a2.07,2.07,0,0,0,0-4.14h-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.87,440.54H272l-1,2.6a1.12,1.12,0,0,1-1,.7,1.16,1.16,0,0,1-.38-.06,1.13,1.13,0,0,1-.66-1.44l4.42-11.79a1.12,1.12,0,0,1,1.06-.7,1.1,1.1,0,0,1,1.06.7l4.42,11.79a1.13,1.13,0,0,1-.66,1.44,1.12,1.12,0,0,1-1.4-.64Zm-.82-2.2-1.62-4.3-1.62,4.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.23,436.64a7.34,7.34,0,0,1,7.34-7.21,7.48,7.48,0,0,1,4.62,1.56,1.15,1.15,0,0,1-1.4,1.82,5,5,0,0,0-3.22-1.1,5.29,5.29,0,0,0-3.6,1.44,5,5,0,0,0-1.46,3.49,4.86,4.86,0,0,0,1.46,3.48,5.29,5.29,0,0,0,3.6,1.44,5,5,0,0,0,3.22-1.1,1.21,1.21,0,0,1,1.6.22,1.18,1.18,0,0,1-.2,1.6,7.48,7.48,0,0,1-4.62,1.56A7.32,7.32,0,0,1,281.23,436.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.27,442.74V431a1.1,1.1,0,0,1,2.2,0v5.75l6.48-6.51a1.09,1.09,0,0,1,1.56,0,1.12,1.12,0,0,1,0,1.56l-4.4,4.38,4.44,5.83a1.07,1.07,0,0,1-.16,1.54,1,1,0,0,1-.7.26,1.08,1.08,0,0,1-.82-.4l-4.32-5.66-2.08,2.12v2.84a1.1,1.1,0,1,1-2.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.98 441.25 196.06 436.63 200.98 432.02 202 433.11 198.23 436.63 202 440.16 200.98 441.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.16,444.62a8,8,0,1,1,8-8A8,8,0,0,1,200.16,444.62Zm0-14.48a6.5,6.5,0,1,0,6.49,6.5A6.51,6.51,0,0,0,200.16,430.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.27,252.75a1,1,0,0,0,.65,1.09c1.05.16,2.33.33,3.75.53,4.23-9.18,8.55-16.41,7.33-13.55a51.85,51.85,0,0,0-3.63,14.06c1.65.22,5.5.69,7.42.92,4.42-16.38,9.29-28.42,8.72-24.64-2.32,15.25-1.91,20.23-1.38,25.56,17.93,2.18,41.48,4.76,58.55,6.23,2.79-9,5.4-18.84,5.64-18.12,1.87,5.35,1.83,12.91,1.36,18.71,5.44.43,9.8.66,12.47.66,0,0,2-7.62,2.36-10.14a56.27,56.27,0,0,0-.18-19.46c-1.23-6.56-3.85-12.46-6.3-18.49A.81.81,0,0,0,377,216s0,0,0,0a56,56,0,0,1-3.48-12.29.25.25,0,0,1,0-.1,55.34,55.34,0,0,1-.59-9.29c.22-11.38-4.88-21.61-14.57-25.31-16.55-16.91-39.28-9.15-45.7,5.15l0,0c-2.51,6.41-5,14.78-7.17,21.23,0,0,0,0,0,0a.07.07,0,0,1,0,.07v0a65.64,65.64,0,0,1-2.91,7.42C296.63,214.4,285.17,220.34,280.27,252.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.35,172.37c6.21,4.11,9.75,9.72,10,18.06.16,4.86,0,9.59,1.37,14.26,1.37,4.82,3.85,8.88,6.42,12.93,4.07,6.44,6.75,12.76,6.74,20.92s-1.24,18-4.53,25.49c0,.05-.08,0-.06,0,2.8-7.65,3.82-18.43,3.25-26.69-.63-9.08-4.87-15.06-9.13-22.23a38.45,38.45,0,0,1-5.51-18.82c-.12-4.12.32-8.37-.88-12.33-1.42-4.72-4.82-7.91-8.22-10.76C361.35,172.79,361.88,172.06,362.35,172.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,214.81c5.18-6.09,10.47-11.22,13.89-19,3.11-7.09,5.2-14.66,8.35-21.73,0-.12.21-.06.16.07-5,12.6-6.92,25.54-15.66,35.81-4.76,5.58-9.47,10.73-12.89,17.58a67.83,67.83,0,0,0-6.46,23c0,.28-.37.24-.37,0A55.61,55.61,0,0,1,290.36,214.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,370S288.27,383,296.25,381.6s34.92-37.66,40.9-50.81,15.91-78.57,14-85.77-11.9-7.3-20.33,11.26S302.46,315.64,298.91,319,236.11,366.52,240,370Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,377.3c-7.4-3.87-16.41-13.26-22.55-14.24a7.13,7.13,0,0,0-7.67,3.66s-2.82-6.27-8.54-6.24c-2.93,0-5.49,4.72-5.49,4.72s-2.49-4.93-7.56-4.59c-4.05.27-6,4.95-6,4.95s-4.58-3.62-8.62-2c-8.18,3.23-9.54,38,3.06,43.88,5.87,2.74,5.74-5.77,5.74-5.77s3.14,12.2,10.3,12.66,6.33-10.58,6.33-10.58,3.15,11.79,10.62,11.52c7.78-.27,5.06-11.18,5.06-11.18s4.94,7.94,10.61,6.42c9.37-2.5-.7-21.32,1.42-28.89h11.77Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38,369.9c7.33,3.06,15.69-8.51,23.23-5.82,9.78,3.49.74,15.56-14.08,17.52H278.76Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,366.25a.09.09,0,0,0-.18,0c-3.23,11.33-3.32,24.77.73,35.91.13.36.79.31.72-.12C233.11,389.72,232.33,378.66,233.82,366.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.74,365c0-.14-.21-.17-.25,0-3.27,11.7-3,26.83,3.23,39.13.21.42.83.58.62.08C247.85,395.73,246.34,376.19,247.74,365Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.46,404.82c-5.47-12-6.54-24.57-5.78-37.63,0-.17-.23-.17-.28,0-2.11,6.29-1.72,14.66-.87,21.15A34.7,34.7,0,0,0,267,405C267.18,405.21,267.58,405.08,267.46,404.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,363.16c-4.8-1.6-9.73,2.24-13.77,4.39a24,24,0,0,1-4.07,1.93c-3.2,1-5.57.36-7-.53-2.24-1.43-9.23-8.41-14.28-6.09a10.76,10.76,0,0,0-4.32,3.67c-1.54-2.8-3.51-5.85-6.92-6.41a5.4,5.4,0,0,0-4.28,1.11,8.78,8.78,0,0,0-1.68,1.71,7.93,7.93,0,0,0-1.16,1.91.64.64,0,0,1,0-.07l-.11-.21-.21-.43a4.49,4.49,0,0,0-1.19-1.49,1,1,0,0,0-.73-.3.08.08,0,0,0,0,.16,1.16,1.16,0,0,1,.54.53c.16.24.31.49.48.72s.33.47.5.7l.25.37.11.19a1.29,1.29,0,0,0,.16.17.15.15,0,0,0,.24,0s0,0,0,0a10,10,0,0,0,1.39-1.52,12,12,0,0,1,1.67-1.6,5.19,5.19,0,0,1,4.11-1c3.06.6,5,3.32,6.63,5.75,0,0,0,0,.05,0h0c-.05.08.06.15.12.09,1.68-1.47,3.28-3.12,5.6-3.46,2.5-.37,4.87.83,6.94,2.09a32,32,0,0,1,3,2c.85.66,1.66,1.4,2.57,2,3.89,2.45,8.15.55,9.21.1a53.35,53.35,0,0,0,6.07-3.22,17.12,17.12,0,0,1,6.5-2.63,6.39,6.39,0,0,1,5.78,2.16c.73.94,1.66,2.7-.25,6.71,0,0,0,.08.06.05C308.2,371.67,311.38,365.23,305.19,363.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.36,305.78l-45.55-7.28s21.76-43.09,34.83-55.59c12.9-12.34,19.18.3,17.28,19.36C351.82,283.4,347.36,305.78,347.36,305.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,297.3c-1.28-.3-2.59-.49-3.87-.78s-2.51-.47-3.77-.66c-2.57-.4-5.15-.76-7.72-1.11-5.08-.7-10.16-1.47-15.26-2-2.9-.32-5.78-.76-8.69-1-.09,0-.1.14,0,.16,5.05,1.18,10.19,2,15.31,2.89s10.16,1.61,15.26,2.16c1.43.16,2.87.34,4.3.41s2.95.21,4.42.23A.12.12,0,0,0,345.88,297.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,382H442.63S392.49,257.56,367,239.38c-7.65-5.46-19.84-6.07-28.06,4.89-6.74,9-25.45,44.75-26.3,57.61s9.24,25.57,9.24,25.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.94,297.68c.31-.08.61-.12.91-.18a1.81,1.81,0,0,1,2.21,1.76,1.4,1.4,0,0,0,.64,1.22,1.76,1.76,0,0,0,.75.26,9.15,9.15,0,0,1,.91.18c-.3.08-.6.12-.91.18a1.78,1.78,0,0,1-1-.09,1.86,1.86,0,0,1-1.13-1.73,1.43,1.43,0,0,0-.69-1.19,1.94,1.94,0,0,0-.77-.23C362.55,297.8,362.25,297.76,361.94,297.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8,297.68c.3-.08.6-.12.9-.18a1.81,1.81,0,0,1,2.21,1.76,1.41,1.41,0,0,0,.65,1.22,1.67,1.67,0,0,0,.75.26c.3.06.6.09.9.18-.3.08-.6.12-.9.18a1.81,1.81,0,0,1-1-.09,1.89,1.89,0,0,1-1.13-1.73,1.43,1.43,0,0,0-.69-1.19,1.89,1.89,0,0,0-.77-.23C316.4,297.8,316.1,297.76,315.8,297.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.7,357.62c.3-.08.61-.12.91-.18a1.82,1.82,0,0,1,2.2,1.77,1.44,1.44,0,0,0,.65,1.22,1.75,1.75,0,0,0,.75.25c.3.06.61.1.91.18-.3.09-.61.13-.91.19a1.79,1.79,0,0,1-1-.1,1.88,1.88,0,0,1-1.14-1.73,1.37,1.37,0,0,0-.69-1.18,1.7,1.7,0,0,0-.76-.23C379.31,357.75,379,357.71,378.7,357.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56,300.92c.3-.09.61-.12.91-.18a1.8,1.8,0,0,1,2.2,1.76,1.43,1.43,0,0,0,.65,1.22,1.59,1.59,0,0,0,.75.25c.3.07.61.1.91.19-.3.08-.61.12-.91.18a1.77,1.77,0,0,1-1-.09,1.88,1.88,0,0,1-1.14-1.73,1.39,1.39,0,0,0-.69-1.19,1.84,1.84,0,0,0-.76-.23C400.17,301,399.86,301,399.56,300.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,270.43c.31-.08.61-.12.91-.18a1.78,1.78,0,0,1,1,.07,1.83,1.83,0,0,1,1.19,1.7,1.46,1.46,0,0,0,.65,1.22,1.9,1.9,0,0,0,.75.25c.31.06.61.1.91.18-.3.09-.6.12-.91.19a1.88,1.88,0,0,1-1-.1A1.86,1.86,0,0,1,348.6,272a1.4,1.4,0,0,0-.69-1.18,1.79,1.79,0,0,0-.77-.24C346.84,270.55,346.54,270.52,346.23,270.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06,269.74c.3-.08.6-.12.91-.18a1.83,1.83,0,0,1,1,.07,1.86,1.86,0,0,1,1.2,1.7,1.42,1.42,0,0,0,.65,1.22,1.71,1.71,0,0,0,.75.25c.3.06.6.1.91.18-.31.09-.61.13-.91.19a1.78,1.78,0,0,1-1-.1,1.88,1.88,0,0,1-1.14-1.73,1.39,1.39,0,0,0-.69-1.18,1.7,1.7,0,0,0-.76-.23A9.18,9.18,0,0,1,379.06,269.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,238.23c.3-.08.61-.12.91-.18a1.8,1.8,0,0,1,2.2,1.76,1.41,1.41,0,0,0,.65,1.22,1.71,1.71,0,0,0,.75.26c.3.06.61.09.91.18-.3.08-.61.12-.91.18a1.77,1.77,0,0,1-1-.09,1.88,1.88,0,0,1-1.14-1.73,1.39,1.39,0,0,0-.69-1.19,1.84,1.84,0,0,0-.76-.23C358.42,238.35,358.11,238.31,357.81,238.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,322.76c.3-.08.6-.12.9-.18a1.77,1.77,0,0,1,1,.07,1.83,1.83,0,0,1,1.2,1.69,1.41,1.41,0,0,0,.65,1.22,1.67,1.67,0,0,0,.75.26c.3.06.6.1.9.18-.3.09-.6.12-.9.18a1.81,1.81,0,0,1-1-.09,1.89,1.89,0,0,1-1.13-1.73,1.43,1.43,0,0,0-.69-1.19,1.94,1.94,0,0,0-.77-.23C338.78,322.88,338.48,322.85,338.18,322.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,377.69c.3-.09.61-.13.91-.19a1.82,1.82,0,0,1,2.2,1.77,1.44,1.44,0,0,0,.65,1.22,1.63,1.63,0,0,0,.75.25c.3.06.61.1.91.18-.3.09-.61.13-.91.19a1.79,1.79,0,0,1-1-.1,1.87,1.87,0,0,1-1.14-1.73,1.37,1.37,0,0,0-.69-1.18,1.7,1.7,0,0,0-.76-.23C374.58,377.81,374.27,377.77,374,377.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35,348.17c.3-.08.6-.12.9-.18a1.86,1.86,0,0,1,1,.07,1.84,1.84,0,0,1,1.2,1.7,1.42,1.42,0,0,0,.65,1.22,1.66,1.66,0,0,0,.75.25c.3.06.6.1.91.18-.31.09-.61.12-.91.19a1.91,1.91,0,0,1-1-.1,1.89,1.89,0,0,1-1.13-1.73,1.42,1.42,0,0,0-.69-1.18,1.59,1.59,0,0,0-.77-.23C357,348.29,356.65,348.26,356.35,348.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.74,353.54c.31-.09.61-.13.91-.19a1.82,1.82,0,0,1,2.2,1.77,1.44,1.44,0,0,0,.65,1.22,1.63,1.63,0,0,0,.75.25c.31.06.61.1.91.18a9.18,9.18,0,0,1-.91.19,1.79,1.79,0,0,1-1-.1,1.87,1.87,0,0,1-1.14-1.73,1.38,1.38,0,0,0-.68-1.18,1.79,1.79,0,0,0-.77-.23C324.35,353.66,324.05,353.62,323.74,353.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.36,323.48c.3-.08.6-.12.9-.18a1.83,1.83,0,0,1,2.21,1.77,1.42,1.42,0,0,0,.65,1.22,1.66,1.66,0,0,0,.75.25c.3.06.6.1.9.18-.3.09-.6.12-.9.19a1.82,1.82,0,0,1-1-.1,1.89,1.89,0,0,1-1.13-1.73,1.42,1.42,0,0,0-.69-1.18,1.66,1.66,0,0,0-.77-.23C372,323.6,371.66,323.57,371.36,323.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.05,363.89c.3-.08.61-.12.91-.18a1.78,1.78,0,0,1,1,.07,1.83,1.83,0,0,1,1.19,1.7,1.46,1.46,0,0,0,.65,1.22,1.9,1.9,0,0,0,.75.25c.31.06.61.1.91.18-.3.09-.6.12-.91.19a1.82,1.82,0,0,1-2.15-1.83,1.37,1.37,0,0,0-.69-1.18,1.7,1.7,0,0,0-.76-.24C413.66,364,413.35,364,413.05,363.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,339.22c.3-.08.61-.12.91-.18a1.82,1.82,0,0,1,2.2,1.77,1.42,1.42,0,0,0,.65,1.22,1.59,1.59,0,0,0,.75.25c.3.06.61.1.91.18-.3.09-.61.13-.91.19a1.78,1.78,0,0,1-1-.1,1.87,1.87,0,0,1-1.14-1.73,1.37,1.37,0,0,0-.69-1.18,1.7,1.7,0,0,0-.76-.23C397.11,339.35,396.8,339.31,396.5,339.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68,375.17c.31-.08.61-.12.91-.18a1.82,1.82,0,0,1,2.2,1.77,1.44,1.44,0,0,0,.65,1.22,1.63,1.63,0,0,0,.75.25c.31.06.61.1.91.18a9.18,9.18,0,0,1-.91.19,1.79,1.79,0,0,1-1-.1,1.85,1.85,0,0,1-1.13-1.73,1.42,1.42,0,0,0-.69-1.18,1.79,1.79,0,0,0-.77-.23C432.29,375.3,432,375.26,431.68,375.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,287.46c-.15.27-.34.51-.51.77a1.81,1.81,0,0,1-2.81.31,1.4,1.4,0,0,0-1.32-.4,1.68,1.68,0,0,0-.71.35,8.56,8.56,0,0,1-.77.51c.16-.27.34-.51.51-.77a1.83,1.83,0,0,1,.79-.65,1.86,1.86,0,0,1,2,.42,1.41,1.41,0,0,0,1.33.35,1.74,1.74,0,0,0,.7-.38C348.53,287.8,348.77,287.61,349,287.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,267.21c-.15.27-.34.51-.51.77a1.81,1.81,0,0,1-2.81.31,1.39,1.39,0,0,0-1.32-.4,1.68,1.68,0,0,0-.71.35,8.56,8.56,0,0,1-.77.51c.16-.27.34-.51.51-.77a1.83,1.83,0,0,1,.79-.65,1.86,1.86,0,0,1,2,.42,1.4,1.4,0,0,0,1.33.35,1.74,1.74,0,0,0,.7-.38C336.42,267.55,336.66,267.36,336.93,267.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,322.71c-.16.28-.34.52-.51.77a1.88,1.88,0,0,1-.77.67,1.83,1.83,0,0,1-2-.36,1.43,1.43,0,0,0-1.32-.4,1.69,1.69,0,0,0-.71.35c-.26.17-.5.36-.77.51.15-.27.34-.51.51-.77a1.8,1.8,0,0,1,.78-.65,1.89,1.89,0,0,1,2,.42,1.38,1.38,0,0,0,1.32.35,1.8,1.8,0,0,0,.71-.37C397.52,323.06,397.76,322.87,398,322.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,257.08c-.15.27-.34.51-.51.77a1.84,1.84,0,0,1-.76.66,1.86,1.86,0,0,1-2.05-.35,1.43,1.43,0,0,0-1.32-.41,1.74,1.74,0,0,0-.71.35c-.26.17-.5.36-.77.52.15-.28.34-.52.51-.78a1.74,1.74,0,0,1,.79-.64,1.86,1.86,0,0,1,2,.42A1.44,1.44,0,0,0,366,258a1.87,1.87,0,0,0,.7-.38C367,257.42,367.19,257.23,367.46,257.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.28,242.12c-.15.27-.34.51-.51.77a1.92,1.92,0,0,1-.76.67,1.86,1.86,0,0,1-2.05-.36,1.4,1.4,0,0,0-1.32-.4,1.63,1.63,0,0,0-.71.35c-.26.17-.5.36-.77.51.15-.27.34-.51.51-.77a1.77,1.77,0,0,1,.79-.65,1.86,1.86,0,0,1,2,.42,1.39,1.39,0,0,0,1.33.35,1.74,1.74,0,0,0,.7-.38C345.77,242.46,346,242.27,346.28,242.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.27,276.12c.09.3.12.61.19.91a2,2,0,0,1-.07,1,1.85,1.85,0,0,1-1.7,1.19,1.43,1.43,0,0,0-1.22.65,1.59,1.59,0,0,0-.25.75c-.07.3-.1.61-.19.91-.08-.3-.12-.61-.18-.91a1.7,1.7,0,0,1,.1-1,1.86,1.86,0,0,1,1.73-1.14,1.38,1.38,0,0,0,1.18-.69,1.84,1.84,0,0,0,.23-.76C366.15,276.73,366.19,276.42,366.27,276.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06,329.39c.08.3.12.61.18.91a1.82,1.82,0,0,1-1.77,2.2,1.42,1.42,0,0,0-1.22.65,1.71,1.71,0,0,0-.25.75c-.06.3-.1.61-.18.91-.09-.3-.13-.61-.19-.91a1.78,1.78,0,0,1,.1-1,1.88,1.88,0,0,1,1.73-1.14,1.37,1.37,0,0,0,1.18-.69,1.7,1.7,0,0,0,.23-.76C358.93,330,359,329.69,359.06,329.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,354.07c.09.3.13.6.19.9a1.83,1.83,0,0,1-1.77,2.21,1.42,1.42,0,0,0-1.22.65,1.55,1.55,0,0,0-.25.75c-.06.3-.1.6-.18.9-.09-.3-.13-.6-.19-.9a1.82,1.82,0,0,1,.1-1,1.88,1.88,0,0,1,1.73-1.13,1.42,1.42,0,0,0,1.18-.69,1.79,1.79,0,0,0,.23-.77C428.89,354.67,428.93,354.37,429,354.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6,283.5c.08.3.12.6.18.91a1.83,1.83,0,0,1-.07,1,1.86,1.86,0,0,1-1.7,1.2,1.42,1.42,0,0,0-1.22.65,1.71,1.71,0,0,0-.25.75c-.06.3-.1.6-.18.91-.09-.31-.12-.61-.19-.91a1.82,1.82,0,0,1,1.83-2.15,1.39,1.39,0,0,0,1.18-.69,1.59,1.59,0,0,0,.23-.76C396.48,284.1,396.51,283.8,396.6,283.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6,369c.08.3.12.6.18.9a1.83,1.83,0,0,1-1.77,2.21,1.42,1.42,0,0,0-1.22.65,1.66,1.66,0,0,0-.25.75c-.06.3-.1.6-.18.9-.09-.3-.12-.6-.19-.9a1.91,1.91,0,0,1,.1-1,1.89,1.89,0,0,1,1.73-1.13,1.42,1.42,0,0,0,1.18-.69,1.59,1.59,0,0,0,.23-.77C396.48,369.63,396.51,369.33,396.6,369Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.05,320.05c.09.3.12.61.18.91a1.8,1.8,0,0,1-1.76,2.2,1.43,1.43,0,0,0-1.22.65,1.59,1.59,0,0,0-.25.75c-.07.3-.1.61-.19.91-.08-.3-.12-.61-.18-.91a1.7,1.7,0,0,1,.1-1,1.86,1.86,0,0,1,1.72-1.14,1.39,1.39,0,0,0,1.19-.69,1.84,1.84,0,0,0,.23-.76C412.93,320.66,413,320.35,413.05,320.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.69,331.3c.09.3.12.6.18.9a1.81,1.81,0,0,1-1.76,2.21,1.41,1.41,0,0,0-1.22.65,1.55,1.55,0,0,0-.25.75c-.07.3-.1.6-.19.9-.08-.3-.12-.6-.18-.9a1.74,1.74,0,0,1,.1-1,1.86,1.86,0,0,1,1.72-1.13,1.43,1.43,0,0,0,1.19-.69,1.84,1.84,0,0,0,.23-.77C329.57,331.9,329.61,331.6,329.69,331.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.31,283.5a9.15,9.15,0,0,1,.18.91,1.82,1.82,0,0,1-.06,1,1.86,1.86,0,0,1-1.7,1.2,1.41,1.41,0,0,0-1.22.65,1.59,1.59,0,0,0-.25.75c-.07.3-.1.6-.19.91-.08-.31-.12-.61-.18-.91a1.77,1.77,0,0,1,.09-1,1.88,1.88,0,0,1,1.73-1.14,1.41,1.41,0,0,0,1.19-.69,1.84,1.84,0,0,0,.23-.76C331.19,284.1,331.23,283.8,331.31,283.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75,252.43c.08.3.12.6.18.91a1.83,1.83,0,0,1-.07,1,1.86,1.86,0,0,1-1.7,1.2,1.42,1.42,0,0,0-1.22.65,1.71,1.71,0,0,0-.25.75c-.06.3-.1.6-.18.91-.09-.31-.12-.61-.19-.91a1.82,1.82,0,0,1,.1-1,1.89,1.89,0,0,1,1.73-1.13,1.39,1.39,0,0,0,1.18-.69,1.59,1.59,0,0,0,.23-.76C348.63,253,348.66,252.73,348.75,252.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07,300.46c.08.31.12.61.18.91a1.83,1.83,0,0,1-1.77,2.21,1.42,1.42,0,0,0-1.22.65,1.66,1.66,0,0,0-.25.75c-.06.3-.1.6-.18.9-.09-.3-.13-.6-.19-.9a1.82,1.82,0,0,1,.1-1,1.89,1.89,0,0,1,1.73-1.13,1.42,1.42,0,0,0,1.18-.69,1.79,1.79,0,0,0,.23-.77C343.94,301.07,344,300.77,344.07,300.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1,306.92c.08.3.12.61.18.91a1.82,1.82,0,0,1-1.77,2.2,1.44,1.44,0,0,0-1.22.65,1.75,1.75,0,0,0-.25.75c-.06.3-.1.61-.18.91-.09-.3-.12-.61-.19-.91a1.79,1.79,0,0,1,.1-1,1.88,1.88,0,0,1,1.73-1.14,1.37,1.37,0,0,0,1.18-.69,1.59,1.59,0,0,0,.23-.76C386,307.53,386,307.22,386.1,306.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,360.86c.08.31.12.61.18.91a1.81,1.81,0,0,1-1.76,2.21,1.39,1.39,0,0,0-1.22.65,1.67,1.67,0,0,0-.26.74,9.15,9.15,0,0,1-.18.91c-.08-.3-.12-.6-.18-.91a1.78,1.78,0,0,1,.09-1,1.86,1.86,0,0,1,1.73-1.13,1.43,1.43,0,0,0,1.19-.69,1.94,1.94,0,0,0,.23-.77C347.13,361.47,347.17,361.17,347.25,360.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,291.67c.16-.27.35-.51.52-.77a1.77,1.77,0,0,1,.76-.66,1.84,1.84,0,0,1,2,.35,1.45,1.45,0,0,0,1.33.41,1.71,1.71,0,0,0,.7-.35c.26-.18.5-.36.78-.52-.16.28-.35.52-.52.78a1.78,1.78,0,0,1-.78.64,1.88,1.88,0,0,1-2-.42,1.42,1.42,0,0,0-1.32-.35,1.87,1.87,0,0,0-.7.38C379.41,291.33,379.17,291.52,378.89,291.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,313.88c.15-.27.34-.51.51-.77a1.81,1.81,0,0,1,2.81-.31,1.39,1.39,0,0,0,1.32.4,1.68,1.68,0,0,0,.71-.35,8.56,8.56,0,0,1,.77-.51c-.16.27-.34.51-.51.77a1.82,1.82,0,0,1-2.82.23,1.39,1.39,0,0,0-1.32-.35,1.87,1.87,0,0,0-.7.38C354.89,313.54,354.65,313.73,354.38,313.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.76,346.6c.16-.28.35-.52.52-.77a1.81,1.81,0,0,1,2.81-.31,1.42,1.42,0,0,0,1.32.4,1.68,1.68,0,0,0,.71-.35,8.56,8.56,0,0,1,.77-.51c-.16.27-.34.51-.51.77a1.81,1.81,0,0,1-2.81.23,1.4,1.4,0,0,0-1.33-.35,1.71,1.71,0,0,0-.7.37C338.28,346.26,338,346.44,337.76,346.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.94,380.59c.16-.27.35-.51.52-.77a1.77,1.77,0,0,1,.76-.66,1.86,1.86,0,0,1,2,.35,1.42,1.42,0,0,0,1.32.41,1.71,1.71,0,0,0,.71-.36c.25-.17.49-.35.77-.51-.16.28-.34.52-.51.77a1.82,1.82,0,0,1-.79.65,1.88,1.88,0,0,1-2-.42,1.42,1.42,0,0,0-1.32-.35,1.87,1.87,0,0,0-.7.38C345.46,380.25,345.22,380.44,344.94,380.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.09,343.23c.15-.27.34-.51.51-.77a1.84,1.84,0,0,1,.76-.66,1.86,1.86,0,0,1,2.05.35,1.42,1.42,0,0,0,1.32.41,1.81,1.81,0,0,0,.71-.35c.25-.17.49-.36.77-.52-.16.28-.34.52-.51.78a1.74,1.74,0,0,1-.79.64,1.86,1.86,0,0,1-2-.42,1.44,1.44,0,0,0-1.33-.35,1.87,1.87,0,0,0-.7.38C377.6,342.89,377.36,343.08,377.09,343.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,356.77c.15-.27.34-.51.51-.77a1.9,1.9,0,0,1,.76-.66,1.86,1.86,0,0,1,2,.35,1.43,1.43,0,0,0,1.32.41,1.74,1.74,0,0,0,.71-.35c.26-.17.5-.36.77-.52-.15.28-.34.52-.51.78a1.69,1.69,0,0,1-.79.64,1.86,1.86,0,0,1-2-.42,1.44,1.44,0,0,0-1.33-.35,1.87,1.87,0,0,0-.7.38C399.72,356.43,399.48,356.62,399.21,356.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,367.05c.15-.27.34-.51.51-.77a1.77,1.77,0,0,1,.76-.66,1.86,1.86,0,0,1,2.05.35,1.42,1.42,0,0,0,1.32.41,1.71,1.71,0,0,0,.71-.36c.25-.17.49-.35.77-.51-.16.28-.34.52-.51.77a1.76,1.76,0,0,1-.79.65,1.86,1.86,0,0,1-2-.42,1.44,1.44,0,0,0-1.33-.35,1.87,1.87,0,0,0-.7.38C362.51,366.71,362.27,366.9,362,367.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,380.59c.16-.27.34-.51.51-.77a1.83,1.83,0,0,1,.76-.66,1.86,1.86,0,0,1,2.05.35,1.43,1.43,0,0,0,1.32.41,1.74,1.74,0,0,0,.71-.35c.26-.18.5-.36.77-.52-.15.28-.34.52-.51.78a1.78,1.78,0,0,1-.78.64,1.87,1.87,0,0,1-2-.42,1.43,1.43,0,0,0-1.32-.35,1.83,1.83,0,0,0-.71.38C410.5,380.25,410.26,380.44,410,380.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,344c.15-.28.34-.52.51-.78a1.9,1.9,0,0,1,.76-.66,1.86,1.86,0,0,1,2.05.35,1.43,1.43,0,0,0,1.32.41,1.74,1.74,0,0,0,.71-.35c.26-.17.5-.36.77-.52-.15.28-.34.52-.51.78a1.69,1.69,0,0,1-.79.64,1.86,1.86,0,0,1-2-.42,1.43,1.43,0,0,0-1.32-.35,1.83,1.83,0,0,0-.71.38C415.92,343.66,415.68,343.85,415.41,344Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75,371.74c.16-.28.34-.52.51-.78a1.9,1.9,0,0,1,.76-.66,1.86,1.86,0,0,1,2.05.35,1.43,1.43,0,0,0,1.32.41,1.74,1.74,0,0,0,.71-.35c.26-.17.5-.36.77-.52-.15.28-.34.52-.51.78a1.72,1.72,0,0,1-.78.64,1.87,1.87,0,0,1-2-.42,1.4,1.4,0,0,0-1.32-.34,1.68,1.68,0,0,0-.71.37C328.26,371.39,328,371.58,327.75,371.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,314.65c.15-.27.34-.51.51-.77a1.92,1.92,0,0,1,.76-.67,1.86,1.86,0,0,1,2.05.36,1.4,1.4,0,0,0,1.32.4,1.52,1.52,0,0,0,.71-.35c.26-.17.5-.36.77-.51a8.56,8.56,0,0,1-.51.77,1.8,1.8,0,0,1-.78.65,1.87,1.87,0,0,1-2-.42,1.4,1.4,0,0,0-1.32-.35,1.83,1.83,0,0,0-.71.38C325.52,314.31,325.28,314.5,325,314.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63,238.48c-.37,1.87-8.81,14.18-17.29,14.07-2.76-.05-3.2-15.13-3.2-15.13l-.29-1.1-4-15.48,17.93-12.37,2.6-1.64s.81,4.31,1.78,9.68c0,.25.09.5.13.77s.13.58.17.87c.16.8.31,1.62.45,2.44.11.62.21,1.22.3,1.88s.19,1.3.3,2A103,103,0,0,1,357.63,238.48Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.16,216.51a32.11,32.11,0,0,1-18.31,19.81l-4-15.48,17.93-12.37,2.6-1.64S354.19,211.14,355.16,216.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,197.85c-.74,28.06,16,31.67,22,31.82,5.49.14,24.21-.08,27.85-27.91s-9.18-37-21.72-38S311.61,169.79,310.87,197.85Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,189.36c.66-.11,1.24-.31,1.88-.48a3.2,3.2,0,0,0,1.82-.86,1,1,0,0,0-.05-1.22,2.49,2.49,0,0,0-2.47-.47,3.62,3.62,0,0,0-2.22,1.38A1.07,1.07,0,0,0,315.13,189.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,193.46a17.47,17.47,0,0,1-1.92-.32,3.14,3.14,0,0,1-1.88-.69,1,1,0,0,1-.06-1.22,2.49,2.49,0,0,1,2.42-.69,3.62,3.62,0,0,1,2.33,1.19A1.06,1.06,0,0,1,333.89,193.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.27,198.49c0-.07-.14.1-.14.18.19,1.9.09,4.11-1.59,4.86-.06,0,0,.12,0,.11C319.64,203.2,319.75,200.26,319.27,198.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,196.61c-3.08,0-2.91,6.14-.05,6.17S320,196.64,317.43,196.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.16,197.06c-.48.34-.94.94-1.53,1s-1.19-.59-1.64-1.22c0-.06-.09,0-.09.07,0,1.18.43,2.4,1.56,2.59s1.77-.85,2-2C316.53,197.25,316.35,196.92,316.16,197.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82,214.82c-.47.43-.95,1-1.65,1.07a5.06,5.06,0,0,1-2-.56.07.07,0,0,0-.09.1,2.57,2.57,0,0,0,2.4,1.12,2,2,0,0,0,1.56-1.64C332,214.8,331.89,214.76,331.82,214.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.26,207.15s-.22,2.86-.15,4.2a27.7,27.7,0,0,1,7.8.68c.6.16.56-.33-.12-.69a11.44,11.44,0,0,0-6.59-1.22c-.12-.37.43-4.4.22-4.4a11.73,11.73,0,0,0-3,.86c.3-6,1.56-11.84,1.77-17.79a.18.18,0,0,0-.35-.07c-1.76,6.07-2.26,12.93-2.73,19.09C319.05,208.57,321.74,207.41,322.26,207.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.61,198.59a6.1,6.1,0,0,0-3.53-.28,5,5,0,0,0-1.76.78,4.54,4.54,0,0,0-1.31,1.54l-.59,1.09,1.21-.13a12.15,12.15,0,0,1,2.56,0,5.24,5.24,0,0,1,2.48.88,3.83,3.83,0,0,0-2.26-1.83,7.16,7.16,0,0,0-2.92-.33l.62,1a4.46,4.46,0,0,1,2.26-1.89A13.48,13.48,0,0,1,335.61,198.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.14,203.56a10.1,10.1,0,0,1-2.59-1c-.19-.12-.92-.67-.88-.83a5.69,5.69,0,0,1,.48-1.34,3.7,3.7,0,0,0-.75,1.3,1.85,1.85,0,0,0,.94,1.25A5.37,5.37,0,0,0,332.14,203.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,211.15s1.74,2.5,3.74,2.8c2.3.36,2.57-1.71,0-2.89C327.94,210.45,325.5,211.15,325.5,211.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,214a4.66,4.66,0,0,1-2.31-1.23c.48-.71,1.58-1.5,4.05-.17C331.33,213.44,330.69,214.18,329.23,214Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.55,202.43c-4.62.58-6.16-9.09-6.16-9.09s-9.42.48-13.19-12.92a20.91,20.91,0,0,0,4.72,11s-16.71-1-24.38-14.53c0,0,3.14,6.95,5.88,9.34,0,0-7.07-1.6-10.74-7.1,0,0-2.52,8.17-4.65,10.5,0,0-.73-29.11,26.36-27.33,0,0,16.92.3,23.63,13.36S360.55,202.43,360.55,202.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23,203.79s5.59-9.11,9.69-7.17.26,14.9-4.29,16.91a4.74,4.74,0,0,1-6.5-2.16Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.73,200.31c.07,0,.09.09,0,.12-3.19,1.52-4.72,4.65-5.74,7.87.9-1.27,2.18-2,3.87-1,.09.05,0,.19-.08.18a2.9,2.9,0,0,0-3.14,1.21,13.32,13.32,0,0,0-1.38,2.68c-.14.3-.67.18-.58-.16a.19.19,0,0,1,0-.08C357.4,207,360.28,201,364.73,200.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,212.07a1.31,1.31,0,1,0,1.23-1.38A1.3,1.3,0,0,0,359,212.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.14,209.9a.84.84,0,1,0,.79-.88A.83.83,0,0,0,362.14,209.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.63,
    y: 265.59,
    width: 14.91,
    height: 46.16,
    transform: "translate(-58.33 68.36) rotate(-13.08)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.74,145.13a63,63,0,1,0,75.65,47.14A63,63,0,0,0,235.74,145.13ZM261.26,255a49.76,49.76,0,1,1,37.2-59.71A49.76,49.76,0,0,1,261.26,255Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.59,
    y: 296.99,
    width: 22.54,
    height: 67.59,
    rx: 6.27,
    transform: "translate(-67.61 71.67) rotate(-13.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.46,195.27a49.75,49.75,0,1,1-59.72-37.22A49.74,49.74,0,0,1,298.46,195.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.68,209.29a49.78,49.78,0,0,1-52,46.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.79,164.6l-71.23,64.29a49.47,49.47,0,0,1-4-11.11,48.81,48.81,0,0,1-1.24-13.47l52.59-47.47A49.69,49.69,0,0,1,276.79,164.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.09,190.5l-67.85,61.23a49.69,49.69,0,0,1-8.43-4.93l72.25-65.2A48.13,48.13,0,0,1,297.09,190.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,168.66,209,234.76c-.34-.5-.68-1-1-1.51l72.84-65.73C281.34,167.88,281.81,168.25,282.26,168.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.32,158.68,203.82,188c.55-1.39,1.17-2.75,1.85-4.07l26.43-23.86C233.47,159.56,234.88,159.09,236.32,158.68Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.68,215.13a1.42,1.42,0,0,1,0-.2c-.18-1,.13.95,0,.3s-.2-1.54-.26-2.31a48.34,48.34,0,0,1,0-8.16c0-.39.07-.77.1-1.15,0-.12-.11.9,0,.09l.09-.7c.12-.9.27-1.8.45-2.69a44.45,44.45,0,0,1,1.53-5.79c.15-.45.32-.9.48-1.35.21-.61-.28.67.05-.13l.33-.79c.43-1,.9-2,1.4-3s1.15-2.07,1.78-3.06c.3-.46.6-.91.91-1.36.53-.77-.25.31.16-.23l.59-.78a45.84,45.84,0,0,1,6.08-6.3s.46-.37.12-.09.18-.15.24-.2l1-.79c.67-.5,1.35-1,2.05-1.44a51.79,51.79,0,0,1,4.54-2.71,3.75,3.75,0,0,0-4-6.36c-9.88,5.27-18,13.59-22.08,24.08a51.69,51.69,0,0,0-3.45,22.19,37.14,37.14,0,0,0,.64,5,3.76,3.76,0,0,0,4.66,2.53,3.87,3.87,0,0,0,2.53-4.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,225.77a3.68,3.68,0,1,1-4.58-2.48A3.67,3.67,0,0,1,218,225.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.13,257.3c9,32.54,13.32,65.21,8.34,82.06-3.18,10.74-10.85,18-15.73,20.4-11.41,5.64-49.26-2.36-73.92-7.32-6.06-1.22,8.23-50.05,14.32-47.46,9,3.81,36.55,8.95,37.31,9.2,1.63.56,5-34.75,7.38-55.45C358.12,229.89,371.94,238.51,377.13,257.3Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,295.68c-2.68,4.37.8,8.37.8,8.37a10.92,10.92,0,0,0-5.12,5.39c-1.61,4.2,4.27,8.57,4.27,8.57a13.41,13.41,0,0,0-4.49,6.54c-1.14,4.18,4.17,9.43,4.17,9.43a11.81,11.81,0,0,0-.33,8.24c2.65,7.11,14,9.44,21.2,11s29.08-.8,33.3-.82l10.35-46.13s-30.31-16.15-39-16.77C266.19,289,251.44,290.78,248.43,295.68Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.71,303.38c8-1.31,15.86-.21,23.81.44a.14.14,0,0,1,0,.28c-7.91-.74-15.86.09-23.77-.33A.2.2,0,0,1,249.71,303.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,317.44a20.65,20.65,0,0,1,5.48.35q2.89.38,5.77.86,5.77,1,11.48,2.21c.17,0,.16.3,0,.27-3.84-.63-7.68-1.2-11.53-1.67-1.93-.24-3.86-.45-5.8-.66a24.76,24.76,0,0,1-5.43-.83A.28.28,0,0,1,248.67,317.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22,334c1.56-.27,3.38.29,4.92.58,1.75.33,3.49.64,5.24.95,3.5.62,7,1.23,10.52,1.73.17,0,.15.3,0,.27-3.58-.48-7.16-.92-10.73-1.43-1.75-.25-3.51-.52-5.26-.79-1.49-.23-3.37-.35-4.7-1.13A.1.1,0,0,1,248.22,334Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.31,290.9c-3.63.47-7.79,1.27-10.14,4.36a6.56,6.56,0,0,0-1.49,4.69,6.31,6.31,0,0,0,2.24,4.05h0a8.1,8.1,0,0,0-5.54,6.6,5.52,5.52,0,0,0,1.43,4.17c.5.59,1.07,1.11,1.62,1.65s1.16,1,1.73,1.47a15.22,15.22,0,0,0-1.73,1.58,12.17,12.17,0,0,0-1.61,1.9,8.49,8.49,0,0,0-1.58,4.65,8.34,8.34,0,0,0,1.66,4.59,9.51,9.51,0,0,0,3.33,3.34.08.08,0,0,0,.09-.13,13.72,13.72,0,0,1-2.71-3.41,8.77,8.77,0,0,1-1.37-4.54,9.1,9.1,0,0,1,1.5-4.27,22.43,22.43,0,0,1,1.38-2,17.47,17.47,0,0,0,1.38-1.66s-1.19-1.26-1.61-1.8-.83-1.12-1.21-1.71a5.52,5.52,0,0,1-1-3.87,7.13,7.13,0,0,1,1.68-3.44c.84-1,1.93-1.79,2.81-2.77a.45.45,0,0,0,.05-.35c-2-3.12-1.75-6.08.39-8.39a13.58,13.58,0,0,1,3.77-2.73,33.53,33.53,0,0,1,5-1.81C258.45,291.06,258.42,290.89,258.31,290.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.61,358.09c-2.13-.66-4.38-1-6.56-1.48s-4.38-.93-6.58-1.37-4.49-.88-6.73-1.3-4.33-.89-6.51-1.15a26.73,26.73,0,0,0-6.32.14q-3.17.36-6.36.51a91.85,91.85,0,0,1-12.85-.28,86.87,86.87,0,0,1-14.31-2.55c-.1,0-.13.12,0,.15a77.78,77.78,0,0,0,25.23,4c2.12,0,4.25-.13,6.36-.34a56.63,56.63,0,0,1,6.36-.54,40.91,40.91,0,0,1,6.68,1c2.21.41,4.41.83,6.62,1.22,2.5.44,5,.89,7.51,1.28s5,.95,7.46,1.13C324.79,358.47,324.8,358.14,324.61,358.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.67,316.2c-3.2-1.09-6.58-1.77-9.87-2.56s-6.62-1.55-9.93-2.3c-6.32-1.43-12.72-2.64-19-4.39-1.65-.46-3.28-1-4.89-1.54-.81-.29-1.6-.61-2.39-1s-1.7-.63-2.48-1c-.09-.06-.16.08-.07.14.63.39,1.21.86,1.86,1.24s1.44.76,2.18,1.1a41,41,0,0,0,4.15,1.63c2.94,1,6,1.69,9,2.39,6.6,1.51,13.21,3,19.83,4.43,1.86.4,3.73.8,5.6,1.17s3.91.83,5.89,1.05A.19.19,0,0,0,355.67,316.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.26,304.1,391,310.32s-8.36-47.55-17.25-63.3c-8.77-15.54-18.45-5.27-22.14,13.53C347.47,281.39,345.26,304.1,345.26,304.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.57,303.43c-1.28-.3-2.59-.49-3.87-.77s-2.51-.47-3.77-.67c-2.57-.4-5.15-.76-7.73-1.11-5.08-.7-10.15-1.47-15.25-2-2.9-.32-5.79-.75-8.69-1a.08.08,0,0,0,0,.16c5.05,1.18,10.2,2.06,15.32,2.89s10.16,1.61,15.26,2.17c1.43.15,2.86.34,4.3.41s2.95.2,4.42.23A.13.13,0,0,0,387.57,303.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.63,130.91a30.52,30.52,0,0,1-51,19.31l-15.28,2.25L354,139.26a30.54,30.54,0,1,1,58.65-8.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.63,130.91a30.66,30.66,0,0,1-6.16,15.48,28,28,0,0,1-6,5.91,31,31,0,0,1-15.59,6.06,28.56,28.56,0,0,1-4.24.08,25.92,25.92,0,0,1-4.22-.44,30.81,30.81,0,0,1-15.11-7.45l.36.11L346.42,153l-1.11.17.56-1,7.6-13.23,0,.52a30.91,30.91,0,0,1,38.29-41,31.26,31.26,0,0,1,11.77,7.22A30.66,30.66,0,0,1,412.63,130.91Zm0,0a30.2,30.2,0,0,0-34.62-33,30.06,30.06,0,0,0-12.62,5,31.4,31.4,0,0,0-9.13,10,30.16,30.16,0,0,0-3.88,12.92,30.69,30.69,0,0,0,2.15,13.3l.11.28-.14.25-7.69,13.18-.55-.81,15.29-2.14.21,0,.15.14a30.16,30.16,0,0,0,14.63,7.53,26.17,26.17,0,0,0,4.14.51,30.69,30.69,0,0,0,4.18,0,30,30,0,0,0,8.15-1.8,28.38,28.38,0,0,0,7.37-4,33,33,0,0,0,3.22-2.69,34.59,34.59,0,0,0,2.78-3.15A30.68,30.68,0,0,0,412.63,130.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,142a3,3,0,0,1,3-3.14,3.14,3.14,0,0,1,0,6.28A3,3,0,0,1,367.33,142Zm1.27-7.24-.71-24.31h4.86L372,134.73Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,142a3,3,0,0,1,3-3.14,3.14,3.14,0,0,1,0,6.28A3,3,0,0,1,379,142Zm1.27-7.24-.71-24.31h4.86l-.71,24.31Z",
    style: {
      fill: "#C9221A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.63,142a3,3,0,0,1,3-3.14,3.14,3.14,0,0,1,0,6.28A3,3,0,0,1,390.63,142Zm1.27-7.24-.71-24.31h4.86l-.71,24.31Z",
    style: {
      fill: "#C9221A"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.390adaf8ecdc8dd5f07b7ea9ac220971.svg";
export { ForwardRef as ReactComponent };